import { render, staticRenderFns } from "./matchingReviews.vue?vue&type=template&id=7fd5abe3&"
import script from "./matchingReviews.vue?vue&type=script&lang=js&"
export * from "./matchingReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports